<section class="section white-100" *ngIf="investorData" id="meetInvestor">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-48">Backed by Strong Investors</h2>
    <div class="section-customer-logos">
      <figure class="investors-logos" *ngFor="let logo of investorData.logos">
        <img src="{{ logo.fields.file.url }}" alt="{{ logo.fields.title }}" />
      </figure>
    </div>
  </div>
</section>
